"use client";

import useSWR from "swr";

import { IPromptAI } from "@/interfaces/prompt-ai.interface";
import promptAIService from "@/services/prompt-ai.service";
import { IFilter } from "@/types/filter.types";
import {
  GetRequestProps,
  PaginatedResponse,
  RequestPagination,
  RequestsBaseReturn,
} from "@/types/requests.types";

const GET_PROMPT_AI_SWR_KEY = "getPromptAI";

type GetPromptAISwrParams = [string, number, number, IFilter<IPromptAI>[], boolean];

export interface UseGetPromptAIProps extends RequestPagination, GetRequestProps {
  filters: IFilter<IPromptAI>[];
  fetchAll?: boolean;
}

export type UseGetPromptAIReturn = RequestsBaseReturn<PaginatedResponse<IPromptAI> | null>;

const useGetPromptAI = ({
  pageNumber,
  pageSize,
  filters,
  fetchAll = false,
  isPaused = false,
}: UseGetPromptAIProps): UseGetPromptAIReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<IPromptAI>, Error, GetPromptAISwrParams>(
    [GET_PROMPT_AI_SWR_KEY, pageNumber, pageSize, filters, fetchAll],
    ([, _pageNumber, _pageSize, _filters, _fetchAll]) =>
      _fetchAll
        ? promptAIService.filterAll(_filters, _pageSize)
        : promptAIService.filter(_filters, {
            pageNumber: _pageNumber,
            pageSize: _pageSize,
          }),
    {
      revalidateOnFocus: false,
      keepPreviousData: true,
      isPaused: () => isPaused,
    }
  );

  return { data, isLoading, error };
};

export default useGetPromptAI;
